<template>
    <div>
        <edition-input v-model="form.edition"
                       :errors="errors.edition"
                       :clearable="true"
                       :required="false"/>
        <el-form-item label="Rodzaj wydarzenia" required
                      :error="errors['event_type']">
            <el-select filterable v-model="form.event_type" placeholder="Wybierz typ wydarzenia">
                <el-option v-for="type in types"
                           :key="type"
                           :label="translateType(type)"
                           :value="type"/>
            </el-select>
        </el-form-item>
        <el-form-item label="Kolor tła"
                      :error="errors['bg_color']">
            <el-color-picker v-model="form.bg_color"/>
        </el-form-item>
        <el-form-item label="Kolor tekstu"
                      :error="errors['text_color']">
            <el-color-picker v-model="form.text_color"/>
        </el-form-item>
    </div>
</template>
<script>
    import {OtherEvent} from '@/api'
    import EditionInput from '@/components/EditionInput'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                types: ["cinema", "theater"]
            }
        },
        methods: {
            translateType (type) {
                const translations = {
                    "music": "koncerty",
                    "cinema": "kino",
                    "theater": "teatr"
                }
                return translations[type] || type
            },
            fetchData () {
                OtherEvent.eventTypes().then(response => {
                    this.types = ["cinema", "theater", ...response.data]
                })
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            EditionInput
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// WhatWePlayWidget.vue?0961d8e5